<template>
  <div>
    <CarrosselModalTemplate
      v-if="!panelMode"
      :edit="edit"
      :setoresFolha="setoresFolha"
      :paginasEstaticas="paginasEstaticas"
      :paginasNavegacao="navigationPages"
      :slide="slide"
      :refreshSlideAction="refreshSlideAction"
      @data-reload="dadosComponenteFilho"
      ref="modal"
    />

    <v-dialog
      v-model="dialog"
      width="500"
      :dark="darkEnabled"
      content-class="carrossel-modal-dialog"
    >
      <v-card :dark="darkEnabled">
        <v-card-title class="text-h5 carrossel-dialog-title">
          Imagem
        </v-card-title>

        <v-card-text>
          <img
            :src="slide.image"
            alt="Imagem carrossel"
            class="imagem-container"
          />
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card v-if="!panelMode" class="card-imagem" :dark="darkEnabled">
      <v-img
        :src="slide.image"
        height="125"
        class="grey darken-4 imagem"
        cover
        @click="dialog = true"
      ></v-img>

      <v-card-title class="text-h6">
        <FormAutocomplete
          v-model="edit.actionType"
          placeholder="Selecione a ação"
          :options="select"
        />

        <FormField
          v-if="hasTextInput"
          v-model="edit.param"
          :placeholder="linkPlaceholder"
        />
        <FormSwitch
          label="Combo específico"
          v-if="hasSelectedCombination"
          v-model="edit.combo.comboEspecifico"
        />

        <a
          class="selecao-acao-imagem"
          v-show="hasSelectTarget"
          @click="$refs.modal.openModal()"
        >
          {{ labelCategoria }}
        </a>

        <a
          class="selecao-acao-imagem"
          v-show="hasSelectedProduct"
          @click="$refs.modal.openModal()"
        >
          {{ labelProduct }}
        </a>

        <a
          class="selecao-acao-imagem"
          v-show="hasSelectedCombination && edit.combo.comboEspecifico"
          @click="$refs.modal.openModal()"
        >
          {{ labelCombination }}
        </a>

        <small
          class="pagina-combo-texto"
          v-show="hasSelectedCombination && !edit.combo.comboEspecifico"
        >
          {{ combinationPageText }}
        </small>

        <a
          class="selecao-acao-imagem"
          v-show="hasSelectedStaticPages"
          @click="$refs.modal.openModal()"
        >
          {{ labelStaticPage }}
        </a>

        <v-tooltip bottom max-width="260" v-if="hasSelectedNavigationPages">
          <template v-slot:activator="{ on }">
            <a
              class="selecao-acao-imagem"
              v-on="on"
              @click="$refs.modal.openModal()"
            >
              {{ labelNavigationPage }}
            </a>
          </template>
          <span>{{ navigationPagesHint }}</span>
        </v-tooltip>

        <div class="botao-exclusao" v-if="!panelMode">
          <i class="fas fa-trash iconTrash" @click="deleteSlide(slide.id)"></i>
        </div>
      </v-card-title>
    </v-card>

    <div v-else class="panel-mode-actions">
      <label class="panel-mode-label">Ao clicar neste banner</label>
      <FormAutocomplete
        v-model="edit.actionType"
        placeholder="Selecione a ação"
        :options="select"
      />

      <FormField
        v-if="hasTextInput"
        v-model="edit.param"
        :placeholder="linkPlaceholder"
      />

      <FormSwitch
        label="Combo específico"
        v-if="hasSelectedCombination"
        v-model="edit.combo.comboEspecifico"
      />

      <FormAutocomplete
        v-if="hasSelectTarget"
        v-model="selectedCategoriaId"
        placeholder="Selecione a categoria"
        :options="categoriaOptions"
      />

      <FormTags
        v-if="hasSelectedProduct"
        v-model="productTagModel"
        placeholder="Pesquise pelo nome, código interno ou código de barras"
        :endpoint="productEndpoint"
        queryname="filter"
        keyid="idproduto"
        keyvalue="text"
        :multiple="false"
        :searchWithSpaces="true"
      />

      <FormAutocomplete
        v-if="hasSelectedCombination && edit.combo.comboEspecifico"
        v-model="selectedComboId"
        placeholder="Selecione o combo"
        :options="comboOptions"
        :loading="comboLoading"
      />

      <small
        class="pagina-combo-texto"
        v-if="hasSelectedCombination && !edit.combo.comboEspecifico"
      >
        {{ combinationPageText }}
      </small>

      <FormAutocomplete
        v-if="hasSelectedStaticPages"
        v-model="selectedStaticPageSlug"
        placeholder="Selecione a página estática"
        :options="staticPageOptions"
      />

      <FormAutocomplete
        v-if="hasSelectedNavigationPages"
        v-model="selectedNavigationPageValue"
        placeholder="Selecione a página"
        :options="navigationOptions"
        :hint="navigationPagesHint"
        persistenthint
      />
    </div>
  </div>
</template>

<script>
import FormAutocomplete from "@/components/form/FormAutocomplete";
import FormField from "@/components/form/FormField";
import FormSwitch from "@/components/form/FormSwitch";
import FormTags from "@/components/form/FormTags";
import CarrosselModalTemplate from "./CarrosselModalTemplate.vue";
import ApiWeb from "@/service/api-web";
import {
  CARROSSEL_NAVIGATION_PAGES,
  findCategoriaNavigationTarget,
  findNavigationPage,
  resolveActionTypeFromSlide
} from "../../utils/utilCarrossel";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { mapGetters } from "vuex";

export default {
  components: {
    FormAutocomplete,
    FormField,
    FormTags,
    CarrosselModalTemplate,
    FormSwitch
  },
  props: {
    showComponente: Function,
    slide: Object,
    paginasNavegacao: Array,
    paginasEstaticas: Array,
    setoresFolha: Array,
    deleteSlide: Function,
    refreshSlideAction: Function,
    panelMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enumModules: ModulesEnum,
      typeAcao: "",
      actionNavigationTarget: null,
      comboList: [],
      comboLoading: false,
      edit: {
        actionType: "nothing",
        param: null,
        image: "",
        produto: {},
        combo: {
          comboEspecifico: false
        },
        paginaEstatica: {},
        paginaNavegacao: {}
      },
      dialog: false,
      isHydrating: false,
      slideActionSyncTimer: null
    };
  },
  created() {
    if (this.panelMode) {
      this.initFromSlide();
    }
  },
  beforeDestroy() {
    this.flushSlideActionSync();
  },
  computed: {
    ...mapGetters(["darkEnabled", "getFornecedorId", "getEmpresaId"]),
    productEndpoint() {
      return `/api/v1/produtos/s2format-simple?idfornecedor=${this.getFornecedorId}`;
    },
    categoriaOptions() {
      return (this.setoresFolha || [])
        .map(folha => ({
          text: folha.rotulo,
          value: `categoria:${folha.id}`
        }))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
    staticPageOptions() {
      return (this.paginasEstaticas || []).map(page => ({
        text: page.titulo,
        value: page.slug
      }));
    },
    navigationPages() {
      return this.paginasNavegacao?.length
        ? this.paginasNavegacao
        : CARROSSEL_NAVIGATION_PAGES;
    },
    navigationOptions() {
      return this.navigationPages.map(page => ({
        text: page.descricao,
        value: page.value
      }));
    },
    comboOptions() {
      return (this.comboList || []).map(combo => ({
        text: combo.nome,
        value: combo.idcombopromocional
      }));
    },
    selectedCategoriaId: {
      get() {
        const id = this.actionNavigationTarget?.id;
        return id ? String(id).split("|")[0] : null;
      },
      set(value) {
        const option = this.categoriaOptions.find(item => item.value === value);
        this.actionNavigationTarget = value
          ? { id: value, nome: option?.text || "" }
          : null;
      }
    },
    selectedStaticPageSlug: {
      get() {
        return this.edit.paginaEstatica?.slug || null;
      },
      set(value) {
        const page = (this.paginasEstaticas || []).find(
          item => item.slug === value
        );
        this.edit.paginaEstatica = page
          ? {
              descricao: page.titulo,
              id: page.idconteudoestatico,
              slug: page.slug
            }
          : {};
      }
    },
    selectedNavigationPageValue: {
      get() {
        return (
          this.edit.paginaNavegacao?.value ||
          this.edit.paginaNavegacao?.id ||
          null
        );
      },
      set(value) {
        const page = findNavigationPage(this.navigationPages, value);
        this.edit.paginaNavegacao = page ? { ...page } : {};
      }
    },
    selectedComboId: {
      get() {
        return this.edit.combo?.id || null;
      },
      set(value) {
        const combo = (this.comboList || []).find(
          item => item.idcombopromocional === value
        );
        this.edit.combo = {
          ...this.edit.combo,
          id: value,
          nome: combo?.nome || ""
        };
      }
    },
    productTagModel: {
      get() {
        const produto = this.edit.produto;
        if (!produto?.id) return null;

        const [idproduto, idcadastroextraproduto, codigobarras] = String(
          produto.id
        ).split("+");

        return {
          idproduto,
          idcadastroextraproduto,
          codigobarras,
          slug: produto.slug,
          text: produto.label || produto.descricao || "",
          nome: produto.descricao
        };
      },
      set(value) {
        const produto = Array.isArray(value) ? value[0] : value;
        if (!produto) {
          this.edit.produto = {};
          return;
        }

        this.edit.produto = {
          descricao: String(produto.nome || produto.text || "").replace(
            /[^a-zA-Z0-9]/g,
            ""
          ),
          label: produto.text || produto.nome || "",
          id: `${produto.idproduto}+${produto.idcadastroextraproduto}+${produto.codigobarras}`,
          slug: produto.slug
        };
      }
    },
    select() {
      const menu = [
        { text: "Sem ação", value: "nothing" },
        { text: "Ir para categoria", value: "filter:categoria" },
        { text: "Ir para produto", value: "product" },
        { text: "Ir para página estática", value: "static-page" },
        { text: "Ir para combo", value: "combination" },
        { text: "Ir para página da loja", value: "page-selection" },
        { text: "Link externo", value: "link:external" },
        { text: "Link incorporado", value: "link:embedded" }
      ];

      return menu.filter(item => {
        if (
          item.value === "filter:categoria" ||
          item.value === "product" ||
          item.value === "combination"
        ) {
          return this.showComponente([
            this.enumModules.COMMERCE_APP,
            this.enumModules.WEB_COMMERCE,
            this.enumModules.ORCAMENTO_WEB,
            this.enumModules.ORCAMENTO_APP,
            this.enumModules.PORTFOLIO_WEB,
            this.enumModules.PAINEL_CLIENTE
          ]);
        }
        return true;
      });
    },
    combinationPageText() {
      return "Será direcionado para a listagem de combos";
    },
    navigationPagesHint() {
      return (
        'Navega para uma página interna da loja. Use "Link externo" para ' +
        'abrir uma URL em nova aba ou "Link incorporado" para exibir o ' +
        "conteúdo em um modal."
      );
    },
    linkPlaceholder() {
      if (this.edit.actionType === "link:external") {
        return "Informe a URL completa (ex.: https://exemplo.com/promo)";
      }
      if (this.edit.actionType === "link:embedded") {
        return "Informe a URL ou código de incorporação";
      }
      return "Informe o link";
    },
    labelCategoria() {
      return (
        (this.actionNavigationTarget && this.actionNavigationTarget.nome) ||
        "Selecionar categoria"
      );
    },
    labelCombination() {
      return (this.edit.combo && this.edit.combo.nome) || "Selecionar combo";
    },
    labelProduct() {
      return (
        (this.edit.produto &&
          (this.edit.produto.slug || this.edit.produto.descricao)) ||
        "Selecionar produto"
      );
    },
    labelStaticPage() {
      return (
        (this.edit.paginaEstatica &&
          (this.edit.paginaEstatica.titulo ||
            this.edit.paginaEstatica.descricao)) ||
        "Selecionar página estática"
      );
    },
    labelNavigationPage() {
      return (
        (this.edit.paginaNavegacao && this.edit.paginaNavegacao.descricao) ||
        "Selecionar página da loja"
      );
    },
    hasTextInput: function() {
      return ["link"].indexOf(this.edit.actionType.split(":")[0]) >= 0;
    },
    hasSelectTarget: function() {
      return ["filter"].indexOf(this.edit.actionType.split(":")[0]) >= 0;
    },
    hasSelectedProduct() {
      return this.edit.actionType === "product";
    },
    hasSelectedCombination() {
      return this.edit.actionType === "combination";
    },
    hasSelectedStaticPages() {
      return this.edit.actionType === "static-page";
    },
    hasSelectedNavigationPages() {
      return this.edit.actionType === "page-selection";
    }
  },
  methods: {
    initFromSlide() {
      this.isHydrating = true;

      const slideAction = this.slide?.action || { type: "nothing", params: [] };

      this.edit.actionType = resolveActionTypeFromSlide(slideAction);

      if (slideAction.type === "nothing") {
        this.edit.param = null;
      } else {
        this.edit.param =
          slideAction.params?.[0] != null ? slideAction.params[1] : null;
        if (this.edit.param === "nothing") {
          this.edit.param = null;
        }
      }

      if (this.edit.actionType === "filter:categoria") {
        this.actionNavigationTarget = findCategoriaNavigationTarget(
          this.categoriaOptions,
          slideAction.params?.[1]
        );
      } else {
        this.actionNavigationTarget = null;
      }

      if (slideAction.type === "static-page") {
        const page = (this.paginasEstaticas || []).find(
          item =>
            item.idconteudoestatico === slideAction.params?.[0] ||
            item.slug === slideAction.params?.[0]
        );
        this.edit.paginaEstatica = page
          ? {
              descricao: page.titulo,
              id: page.idconteudoestatico,
              slug: page.slug
            }
          : {};
      } else {
        this.edit.paginaEstatica = {};
      }

      if (slideAction.type === "product") {
        this.edit.produto = {
          id: slideAction.params?.[0],
          slug: slideAction.params?.[1],
          label: slideAction.params?.[2] || "",
          descricao: slideAction.params?.[2] || ""
        };
      } else {
        this.edit.produto = {};
      }

      if (slideAction.type === "combination") {
        this.edit.combo = {
          id: slideAction.params?.[0],
          nome: slideAction.params?.[1],
          comboEspecifico: slideAction.params?.[2]
        };
        this.loadCombos();
      } else {
        this.edit.combo = { comboEspecifico: false };
      }

      if (slideAction.type === "page-selection") {
        const page = findNavigationPage(
          this.navigationPages,
          slideAction.params?.[0]
        );
        this.edit.paginaNavegacao = page ? { ...page } : {};
      } else {
        this.edit.paginaNavegacao = {};
      }

      this.$nextTick(() => {
        this.isHydrating = false;
      });
    },
    syncComboLabelFromList() {
      if (this.edit.actionType !== "combination") return;

      const comboId = this.edit.combo?.id;
      if (!comboId) return;

      const combo = (this.comboList || []).find(
        item => item.idcombopromocional === comboId
      );
      if (!combo?.nome) return;

      if (this.edit.combo.nome !== combo.nome) {
        this.edit.combo = {
          ...this.edit.combo,
          nome: combo.nome
        };
      }
    },
    async loadCombos() {
      if (this.comboList.length || this.comboLoading) return;

      this.comboLoading = true;
      try {
        const response = await ApiWeb.api.get(
          `/api/v4/promotional-combos/${this.getFornecedorId}/${this.getEmpresaId}/options`
        );
        this.comboList = response?.data?.data || [];
        this.syncComboLabelFromList();
      } catch {
        this.comboList = [];
        this.$vueOnToast.pop(
          "error",
          "Não foi possível carregar os combos promocionais."
        );
      } finally {
        this.comboLoading = false;
      }
    },
    computeSlideParams() {
      let action = this.edit.actionType;
      const baseAction = action.split(":");
      const actionType = baseAction[0];
      let params = [];

      if (actionType === "filter") {
        const id = this.actionNavigationTarget
          ? String(this.actionNavigationTarget.id).split("|")[0]
          : "";
        params = ["categoria", id];
      } else if (actionType === "nothing") {
        params = [];
      } else if (actionType === "static-page") {
        params = [this.edit.paginaEstatica?.slug || ""];
      } else if (actionType === "page-selection") {
        params = [
          this.edit.paginaNavegacao?.value ||
            this.edit.paginaNavegacao?.id ||
            ""
        ];
      } else if (actionType === "product") {
        const {
          id = "",
          slug = "",
          label = "",
          descricao = ""
        } = this.edit.produto;
        params = [id, slug, label || descricao];
      } else if (actionType === "combination") {
        const { id = "", nome = "", comboEspecifico = false } = this.edit.combo;
        params = [id, nome, comboEspecifico];
      } else {
        if (this.edit.param?.startsWith?.("categoria:")) {
          this.edit.param = "";
          this.actionNavigationTarget = null;
        }
        const linkParam =
          this.edit.param === "nothing" ? "" : this.edit.param || "";
        params = [baseAction[1], linkParam];
      }

      this.refreshSlideAction({
        slideId: this.slide.id,
        params: {
          type: actionType,
          params
        }
      });
    },
    scheduleSlideActionSync() {
      if (!this.panelMode || this.isHydrating) return;

      if (this.slideActionSyncTimer) {
        clearTimeout(this.slideActionSyncTimer);
      }

      this.slideActionSyncTimer = setTimeout(() => {
        this.slideActionSyncTimer = null;
        this.computeSlideParams();
      }, 200);
    },
    flushSlideActionSync() {
      if (this.slideActionSyncTimer) {
        clearTimeout(this.slideActionSyncTimer);
        this.slideActionSyncTimer = null;
      }

      if (!this.panelMode || this.isHydrating || !this.slide?.id) return;
      this.computeSlideParams();
    },
    dadosComponenteFilho(dados) {
      const { type, value } = dados;

      if (type === "edit.paginaEstatica") {
        this.edit.paginaEstatica = value;
      } else {
        this[type] = value;
      }
    }
  },
  watch: {
    slide: {
      immediate: false,
      deep: true,
      handler(newSlide, oldSlide) {
        if (!this.panelMode) return;
        if (
          newSlide?.id !== oldSlide?.id ||
          JSON.stringify(newSlide?.action) !== JSON.stringify(oldSlide?.action)
        ) {
          this.initFromSlide();
        }
      }
    },
    setoresFolha() {
      if (this.panelMode) {
        this.initFromSlide();
      }
    },
    paginasEstaticas() {
      if (this.panelMode) {
        this.initFromSlide();
      }
    },
    paginasNavegacao() {
      if (this.panelMode) {
        this.initFromSlide();
      }
    },
    edit: {
      handler() {
        if (!this.panelMode) return;
        this.scheduleSlideActionSync();
      },
      deep: true
    },
    "edit.actionType"(value, oldValue) {
      if (this.panelMode && value !== oldValue) {
        if (value?.startsWith("link:") && this.edit.param === "nothing") {
          this.edit.param = null;
        }
      }

      if (this.panelMode && value === "combination") {
        this.loadCombos();
      }

      if (!this.panelMode) {
        this.$emit("data-reload", {
          type: "edit.actionType",
          value
        });
      }
    }
  }
};
</script>

<style scoped>
.card-imagem {
  width: 220px;
}

.imagem {
  height: 150px !important;
}

.botao-exclusao {
  width: 100%;
  color: #6a6c6f;
}

.botao-exclusao i {
  cursor: pointer;
}

.botao-exclusao i:hover {
  color: rgb(239, 80, 80);
  transition: 0.3s all ease-in;
}

.pagina-combo-texto {
  width: 100%;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
}

.selecao-acao-imagem {
  width: 100%;
  font-size: 15px;
  margin-bottom: 20px;
  color: #5870ef;
  text-decoration: underline;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.selecao-acao-imagem:hover {
  color: #3b4ca3;
  transition: 0.3s all ease-in;
}

.container-imagem {
  margin-bottom: 20px;
}

.imagem-container {
  margin-top: 30px;
  max-width: 400px;
  max-height: 400px;
}

.panel-mode-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.panel-mode-actions {
  width: 100%;
}
</style>
